var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{on:{"click":_vm.notAll}},[_vm._v("取消")])],1),_c('f7-nav-title',[_vm._v("已选中"+_vm._s(_vm.numShowcheck)+"个文件")]),_c('f7-nav-right',[_c('f7-link',{on:{"click":_vm.all}},[_vm._v("全选")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }